module.exports = __webpack_public_path__ + "static/media/italic.b1c545de.svg";